<template>
  <div id="submit-manuscripts-upload-documents-loading">
    <ipub-model :title="'Review Result Details'"
                width="600px"
                :visable="isVisable"
                :showFooter="false"
                :showHeader="false"
                @cancel="cancel">
      <div class="upload-documents-loading">
        <ipub-icon style="font-size:80px"
                   type="icona-UploadManuscript" />
        <div class="upload-documents-loading-wrap mar-b-10">
          <div :style="{width:(progress.total?(progress.current * 100 / progress.total).toFixed(2):0)+'%'}"
               class="upload-documents-loading-content"></div>
        </div>
        <div class="tr font-color ipub-p2">
          Uploading… {{progress.total?(progress.current * 100 / progress.total).toFixed(2):0}}%
        </div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      progressObj: {}
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.progressObj = {}
      } else {
        this.progressObj = JSON.parse(JSON.stringify(val))
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
#submit-manuscripts-upload-documents-loading {
  .upload-documents-loading {
    text-align: center;
    &-wrap {
      width: 100%;
      height: 4px;
      background: $line_color;
      margin-top: 20px;
    }
    &-content {
      width: 50%;
      height: 100%;
      background: $main_color;
      transition: 0.3s all;
    }
  }
}
</style>
